<template>
  <i18n-t
    tag="p"
    keypath="Expand your search by {removeAppliedMapView} filter."
  >
    <template #removeAppliedMapView>
      <pu-low-results-search-link :modify-filters="modifyFilters">
        <translate>removing your applied map view</translate>
      </pu-low-results-search-link>
    </template>
  </i18n-t>
</template>

<script lang="ts">
import { isLocalStorageAvailable } from '~/utility/isLocalStorageAvailable'
import { Component, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class LowResultsBounds extends Vue {
  isMounted = false

  mounted() {
    this.isMounted = true
  }

  get modifyFilters() {
    return {
      area: this.previousNonBoundsSearch?.area,
      bounds: undefined,
      hierarchyPath: this.previousNonBoundsSearch?.previousPath,
      placename: this.previousNonBoundsSearch?.placename,
    }
  }

  get previousNonBoundsSearch() {
    if (isLocalStorageAvailable() && this.isMounted) {
      const storedPreviousSearch = localStorage.getItem('maps-previous-search')
      return storedPreviousSearch ? JSON.parse(storedPreviousSearch) : undefined
    } else {
      return undefined
    }
  }
}

export default toNative(LowResultsBounds)
</script>
